// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".recommend-background[data-v-096c4c6a]{background-color:#141414;padding:5px}", ""]);
// Exports
module.exports = exports;
